import moment from 'moment'
moment.locale('lt')

export default moment
